import { setExclusiveContent } from '../internal.js';
import * as actionTypes from './actionTypes.js';
const exclusiveContentReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SELECT_EXCLUSIVECONTENT: {
            const exclusiveContent = action.payload.selected
                ? action.payload.selected
                : [];
            setExclusiveContent(exclusiveContent);
            return exclusiveContent;
        }
        default:
            return state;
    }
};
export default exclusiveContentReducer;
//# sourceMappingURL=reducer.js.map